var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wb-logo-wrap",style:(_vm.cssStyle)},[_c('div',{staticClass:"wb-logo",style:({ width: _vm.w, height: _vm.h })},[_c('img',{attrs:{"src":_vm.logoPic}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }